define.alias("shared/components/shared/plan-recommendation/steps/role", "media/components/shared/plan-recommendation/steps/role");